<template>
    <!-- create file on requests & comments -->
    <v-dialog
      v-model="dialog"
      max-width="750px"
    >
    <v-card>
        <v-card-title class="primary">
            <h2>
                <v-icon dark class="mr-2">{{ icon }}</v-icon>
                <span>{{ title }}</span>
            </h2>
            <v-spacer></v-spacer>
            <v-btn small icon @click="onClose()">
                <v-icon dark>close</v-icon>
            </v-btn>
        </v-card-title>
        <div class="pa-3">
            <v-form v-model="isValid" ref="form" @submit.prevent=''>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                @click.native="openInput"
                                color="primary"
                                outline
                                round
                            >
                                {{file_name}}
                                <v-icon right>cloud_upload</v-icon>
                            </v-btn>
                            <!-- hidden input -- click btn like click on input -- for style reason -->
                            <input type="file" ref="fileInput" @change="UploadFile" style="display:none"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field label="Nom" v-model="model.label" :rules="rules.name" required autofocus></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small round outline @click="dialog = false">Annuler</v-btn>
            <v-btn color="primary" small round text-color="white" :loading="loading" @click="onValidate">Valider</v-btn>
        </v-card-actions>
    </v-card>

    </v-dialog>

</template>

<script>
export default {
    data() {
        return {
            title:      'Ajouter un fichier',
            icon:       'file_upload',
            dialog: false,
            warning:    false,
            isValid:    false,
            disableEnter: false,
            model: {
                label: '',
            },
            file:'',
            rules: {
                name: [
                    (v) => !!v || 'Nom du fichier obligatoire',
                ],
            },
            file_name: 'Choisir un fichier',
            tags: [],
            entity: '',
            entity_id: '',
            loading: false,
        }
    },
    methods: {
        // when dialog is open
        open(field,entity_id) {
            this.dialog = true
            this.entity = field
            this.entity_id = entity_id
        },
        // when file change on input
        UploadFile(event) {
            this.file = event.target.files[0]
            this.file_name = this.file.name
            this.model.label = this.file.name.split('.')[0]
        },
        // when click on btn -- click on input
        openInput(){
            this.$refs.fileInput.click()
        },
        // when form is validate
        onValidate() {
            if(this.$refs.form.validate()) {
                this.loading = true
                if(this.entity_id != 0) {
                    this.attachment = this.file
                    // create data object
                    let data = new FormData()
                    // put the file, a file type (attachment) & size (resize on back)
                    data.append('file', this.attachment)
                    data.append('file_type', 'attachment')
                    data.append('size', 750)
                    // post the data object
                    this.axios.post(`/api/${this.entity}/${this.entity_id}/file`, data, {
                    headers: {
                         'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.axios.put(`/api/files/${response.data.id}`, this.model)
                        .then(response => {
                            this.$emit('added',this.entity_id,this.entity)
                            this.loading = false
                            this.onClose()
                        })
                    })
                    .catch(error => {
                    })
                }
            }
        },

        onClose() {
            // reset form on close
            if(this.$refs.form) {
                this.$refs.form.reset()
                this.$refs.fileInput.value = ''
                this.file_name ='Choisir un fichier'
            }
            this.dialog = false
        },
    },
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>
.card{
    .card__title{
        h2 {
            color:#FFF
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/files/CreateLinkedFiles.vue